var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("img", {
          staticClass: "imgageproperty",
          attrs: { src: require("@/assets/img/errorlist.png"), alt: "save" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("ESL Statistics")) + " ")
      ]),
      _c(
        "div",
        { staticClass: "searchArea" },
        [
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "min-width": "290px"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-text-field",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "form-input ml-3",
                              attrs: {
                                value: _vm.searchBy.startDate,
                                label: "" + _vm.$t("Period"),
                                placeholder: "" + _vm.$t("Select start date"),
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                readonly: ""
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.clearDate(
                                    _vm.searchBy,
                                    "startDate"
                                  )
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            width: "16",
                                            height: "16",
                                            src: require("@/assets/img/ico-calendar.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            "v-text-field",
                            attrs,
                            false
                          ),
                          on
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.showStartDatePicker,
                callback: function($$v) {
                  _vm.showStartDatePicker = $$v
                },
                expression: "showStartDatePicker"
              }
            },
            [
              _c("v-date-picker", {
                attrs: {
                  locale:
                    _vm.languageCodes[
                      _vm.$store.getters["dataStore/GET_CURRENT_LANGUAGE"]
                    ],
                  "no-title": ""
                },
                on: {
                  change: _vm.checkStartDate,
                  input: function($event) {
                    _vm.showStartDatePicker = false
                  }
                },
                model: {
                  value: _vm.searchBy.startDate,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "startDate", $$v)
                  },
                  expression: "searchBy.startDate"
                }
              })
            ],
            1
          ),
          _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("~")]),
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "min-width": "290px"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-text-field",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "form-input",
                              attrs: {
                                value: _vm.searchBy.endDate,
                                placeholder: "" + _vm.$t("Select end date"),
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                solo: "",
                                readonly: ""
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.clearDate(_vm.searchBy, "endDate")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            width: "16",
                                            height: "16",
                                            src: require("@/assets/img/ico-calendar.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            "v-text-field",
                            attrs,
                            false
                          ),
                          on
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.showEndDatePicker,
                callback: function($$v) {
                  _vm.showEndDatePicker = $$v
                },
                expression: "showEndDatePicker"
              }
            },
            [
              _c("v-date-picker", {
                attrs: {
                  locale:
                    _vm.languageCodes[
                      _vm.$store.getters["dataStore/GET_CURRENT_LANGUAGE"]
                    ],
                  "no-title": ""
                },
                on: {
                  change: _vm.checkEndDate,
                  input: function($event) {
                    _vm.showEndDatePicker = false
                  }
                },
                model: {
                  value: _vm.searchBy.endDate,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "endDate", $$v)
                  },
                  expression: "searchBy.endDate"
                }
              })
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticClass: "btn type-search ml-3",
              attrs: { text: "" },
              on: {
                click: function($event) {
                  return _vm.getStatisticsInfo(1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Search")))]
          )
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 mt-10",
          attrs: {
            headers: _vm.tableHeaders,
            items: _vm.tableItems,
            "hide-default-footer": true,
            "return-object": ""
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("No data available")))])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.btnDisabledExportCheckList || _vm.exportDisabled,
                  text: ""
                },
                on: { click: _vm.exportUserInfoList }
              },
              [_vm._v(" " + _vm._s(_vm.$t("Export")) + " ")]
            )
          ],
          1
        )
      ]),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }